export default __webpack_public_path__ + "media/images/onglet-rightclick2-c59addbd70f6b740a60673c2e4e5f1f1.png";